var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('GlobalHeader'),_c('transition',{attrs:{"name":"page-fade","mode":"out-in"}},[_c('v-content',{attrs:{"id":"main","role":"main"}},[_c('router-view')],1)],1),_c('GlobalFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }